module.exports = __webpack_public_path__ + "img/the-circus-animal-trainer.810b8c09.png";